var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"towns"},[_vm._v(" "+_vm._s(_vm.town_name)+" ")]),_c('Flow'),_c('Second'),_c('Third')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }